import React from 'react'
import withView from '../../../../cmn/docAutomation/withView';
import FormDialog from '../../../../../library/form/components/FormDialog';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import ProdIOOExiCMNEditor from './ProdIOOExiCMNEditor';
import {CmnMetalSearch} from '../../../../cmn/snippet/Index';
import { UiGridColOne, UiCol } from "../../../../../library/layout/Index";

const ProdIOOExiMetalEditor = (props) => {
    const { formObject, viewData, masterKeys, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ actionParam:{actionType: 'addItem'},formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '250px' }}
            formStyle={{ width: '535px', height:"400px" }} formTitle={<SarasTrans value="Metal Editor" />}
        >
            <UiGridColOne>
                <UiCol>
                    <ul>
                        <li>
                            <CmnMetalSearch formObject={formObject} rowKey="" viewData={viewData} masterKeys={masterKeys} {...restProps} />
                        </li>
                        <ProdIOOExiCMNEditor {...props} />
                    </ul>
                </UiCol>
            </UiGridColOne>
        </FormDialog>
    )
}

export default withView(ProdIOOExiMetalEditor, "prodIOPlan", "prodIOPlan,prodIOSum,prodEOOutputGroup")